// extracted by mini-css-extract-plugin
export default {"new_task_card_wrapper":"NewTaskCard_new_task_card_wrapper__XMJb9","new_task_card_wrapper_inner":"NewTaskCard_new_task_card_wrapper_inner__AoCt1"};